const unsafeCharRegex = /[^0-9a-zA-Z\f\n\r\t\v$()*+.?\\^{}[\]" !#%&'-/@_`:~��=]/;

export default unsafeCharRegex;